import { ReactNode } from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";

export default function ContentWrapper({
  children,
  className,
  refMark,
}: {
  children: ReactNode;
  className?: {};
  refMark?: string;
}) {
  // const wrapperClass = clsx(styles.contentWrapper, className);

  return (
    <div style={className} className={clsx(styles.contentWrapper, refMark)}>
      {children}
    </div>
  );
}
